import { call, put, takeLatest } from 'redux-saga/effects'
import {
  UPDATE_INVOICE,
  UPDATE_INVOICE_SUCCESS,
  UPDATE_INVOICE_FAILURE,
  UpdateInvoiceActionType
} from 'src/redux/invoiceReducer'
import apiCall from 'src/helpers/apiCall'

function* UpdateInvoiceFlow(action: UpdateInvoiceActionType): Generator<any, void, any> {
  try {
    const response = yield call(apiCall, {
      method: 'PUT',
      endpoint: `/dealers_api/invoices/${action.payload.id}`,
      api: 'market-api',
      params: {
        invoice: action.payload.values
      }
    })

    yield put(UPDATE_INVOICE_SUCCESS({ pdf_url: response.pdf_url }))
  } catch (error: any) {
    yield put(UPDATE_INVOICE_FAILURE())
  }
}

export default function* UpdateInvoiceSaga(): Generator<any, void, any> {
  yield takeLatest(UPDATE_INVOICE, UpdateInvoiceFlow)
}
